import { FC } from 'react';
// Types
import QuizTypes from 'types/QuizTypes';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizzesSelectors';
// Components
import Accordion from 'components/Accordion';
// i18next
import { useTranslation } from 'react-i18next';
// Utilities
import ResultsForm from './ResultsForm';

type Props = {
  defaultExpanded?: boolean;
}

const Results:FC<Props> = ({ defaultExpanded }) => {
  const { t } = useTranslation();
  const quiz:IQuiz | null = useAppSelector(selectQuiz);

  const isPollQuizzes = !!quiz && [QuizTypes.Poll, QuizTypes.RankingPoll].includes(quiz.type);
  const isTeamSelectorQuiz = quiz?.type === QuizTypes.TeamSelector;

  const previewPage = isPollQuizzes ? 'results' : isTeamSelectorQuiz ? 'teamboard' : 'leaderboard';

  if (!quiz) return null;
  if ([QuizTypes.Personality, QuizTypes.Survey].includes(quiz.type)) return null;
  return (
    <div react-scroll="results">
      <Accordion
        label={isPollQuizzes || isTeamSelectorQuiz ? t('pages.quizForm.resultsLabel') : t('pages.quizForm.leaderboardLabel')}
        icon="medal"
        previewPage={previewPage}
        defaultExpanded={defaultExpanded}
      >
        <ResultsForm />
      </Accordion>
    </div>
  )
}

export default Results;
